import styled from 'styled-components';
import { Box, Card, CardContent, Typography } from '@mui/material';

export const StatsGrid = styled(Box)`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(200px, 100%), 1fr));
  gap: 16px;
`;

export const StatCard = styled(Card)<{ $bg: string; $fg: string }>`
  background: ${(p) => p.$bg};
  color: ${(p) => p.$fg};
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  transition: transform 120ms ease, box-shadow 120ms ease;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.18);
  }
`;

export const StatCardContent = styled(CardContent)<{ $fg: string }>`
  color: ${(p) => p.$fg};
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const StatText = styled(Box)``;

export const StatCount = styled(Typography)`
  color: inherit !important;
`;

export const StatDescription = styled(Typography)`
  color: inherit !important;
  opacity: 0.9;
`;

export const StatIconWrapper = styled(Box)<{ $fg: string }>`
  color: ${(p) => p.$fg};
  display: flex;
  align-items: center;
  svg {
    font-size: 40px;
    color: inherit;
    transition: transform 120ms ease;
  }
`;
